import { Image } from '../../core/model/image';
import { ModelBase } from '../../core/model/model-base';
import { ObjectComponent } from '../../rent/model/object-component';
import { DwellingInspectionRoom } from './dwelling-inspection-room';
import { FaultNotificationPriority } from '../../fault-notification/model/const/enum';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';
import { ErrandStatus } from '../../round-planning/model/const/enums';
import { DwellingInspectionDeviation } from './dwelling-inspection-deviation';

export enum Assessment {
  NotAssessed = 0,
  Acceptable = 1,
  Bad = 2,
  Good = 3,
}

export class DwellingInspectionPoint extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.payment = dataContext.payment ? new Money(dataContext.payment.currencyCode, dataContext.payment.amount) : null;
      this.assessment = dataContext.assessment;
      this.comment = dataContext.comment ? dataContext.comment : '';
      this.dwellingInspectionRoom = dataContext.dwellingInspectionRoom;
      this.dwellingInspectionRoomCaption = dataContext.dwellingInspectionRoomCaption;
      this.photos = Array.isArray(dataContext.photos)
        ? dataContext.photos.map(x => {
            let i = new Image(x.url);
            i.id = x.id;
            return i;
          })
        : [];
      this.objectComponent = new ObjectComponent(dataContext.objectComponent);
      this.priceListItemId = dataContext.priceListItemId;

      this.priceListQuantity = dataContext.priceListQuantity;
      this.ageReductionAmount = dataContext.ageReductionAmount;
      this.createWorkOrder = dataContext.createWorkOrder;
      this.workOrderTitle = dataContext.workOrderTitle;
      this.workOrderDescription = dataContext.workOrderDescription;
      this.workOrderLocation = dataContext.workOrderLocation;
      this.resourceId = dataContext.resourceId;
      this.workOrderContactInformation = dataContext.workOrderContactInformation;
      this.workOrderPriority = dataContext.workOrderPriority;
      this.workOrderDeadline = LocalDate.fromDate(dataContext.workOrderDeadline);

      this.deviation = dataContext.deviation ? new DwellingInspectionDeviation(dataContext.deviation) : null;
      this.previousDeviations = dataContext.previousDeviations?.map(x => new DwellingInspectionDeviation(x)) ?? [];
      this.componentCategoryName = dataContext.componentCategoryName;
      this.componentTypeName = dataContext.componentTypeName;
      this.dwellingInspectionNumber = dataContext.dwellingInspectionNumber;
      this.dwellingInspectionTypeName = dataContext.dwellingInspectionTypeName;
    }
  }

  assessment: Assessment;
  comment: string;
  get commentPlaceholder() {
    return this.comment ? 'COMMON.EDIT_COMMENT' : 'COMMON.ADD_COMMENT';
  }
  dwellingInspectionRoom: DwellingInspectionRoom | string;
  payment: Money;
  get photoCount(): number {
    return this.photos ? this.photos.length : 0;
  }
  photos: Image[] = [];
  objectComponent: ObjectComponent;
  priceListItemId: string;

  priceListQuantity: number;
  ageReductionAmount: Money;
  createWorkOrder: boolean;
  workOrderTitle: string;
  workOrderDescription: string;
  workOrderLocation: string;
  workOrderContactInformation: string;
  resourceId: string;
  workOrderPriority: FaultNotificationPriority;
  workOrderDeadline: LocalDate;
  deviation: DwellingInspectionDeviation;
  previousDeviations: DwellingInspectionDeviation[];

  // Deviation list data
  componentCategoryName: string;
  componentTypeName: string;
  dwellingInspectionRoomCaption: string;
  dwellingInspectionNumber: number | null;
  dwellingInspectionTypeName: string;

  get unresolvedDeviations() {
    return this.previousDeviations?.filter(x => x.deviationErrands?.find(y => this._unresolvedDeviationErrandStatuses.includes(y.errand.status)));
  }

  private _unresolvedDeviationErrandStatuses: ErrandStatus[] = [
    ErrandStatus.Draft,
    ErrandStatus.New,
    ErrandStatus.Registered,
    ErrandStatus.Started
  ]
}
